import '@swc/helpers';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import { validationErrorLabelMap } from '../../../utils/get-validation-error-codes.js';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';

const getConfirmationModalLabels = (getFormattedLabel, getLabel, validation, lineItems)=>{
    var ref;
    let title, sanitizationAction;
    const { action , lineItemId  } = validation.validationError.actionItem;
    const actionKey = action.toLowerCase();
    const validationErrorCode = validationErrorLabelMap[validation.validationError.validationCode];
    const conflictingProductType = ((ref = lineItems === null || lineItems === void 0 ? void 0 : lineItems.find((lineItem)=>lineItem.id === lineItemId
    )) === null || ref === void 0 ? void 0 : ref.displayType) || '';
    if (validation.singleValidation && conflictingProductType) {
        title = getLabel(`cart.sanitizationAction.${actionKey}.title`);
        sanitizationAction = getFormattedLabel(`cart.sanitizationAction.actionDescription`, {
            labelData: {
                action: actionKey,
                productType: conflictingProductType
            }
        });
    } else {
        title = getLabel(`cart.sanitizationAction.${actionKey}.title.plural`);
        sanitizationAction = getFormattedLabel(`cart.sanitizationAction.actionDescription.generic`, {
            labelData: {
                action: actionKey
            }
        });
    }
    return {
        title,
        errorMessage: getLabel(`cart.${validationErrorCode}`),
        sanitizationAction,
        actionButton: getLabel(`cart.sanitizationAction.confirm`),
        cancelButton: getLabel(`cart.sanitizationAction.cancel`)
    };
};

export { getConfirmationModalLabels };
//# sourceMappingURL=get-confirmation-modal-labels.js.map
